import { cn } from '@/lib/utils';

interface EllipsisLoaderProps {
    className?: string;
}

export function EllipsisLoader({ className }: EllipsisLoaderProps) {
    return (
        <div
            className={cn('flex items-center gap-1', className)}
            role="status"
            aria-label="Loading"
        >
            <span className="size-2 rounded-full bg-muted-foreground animate-bounce [animation-delay:-0.3s]" />
            <span className="size-2 rounded-full bg-muted-foreground animate-bounce [animation-delay:-0.15s]" />
            <span className="size-2 rounded-full bg-muted-foreground animate-bounce" />
        </div>
    );
}
